<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<h4>基本信息</h4>
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="课程名称" prop="name" :label-width="labelWidth">
					<el-input style="width: 650px;" v-model="ruleForm.name"
						placeholder="请输入1-30个字符，仅支持字母/汉字/数字"></el-input>
				</el-form-item>
				<el-form-item label="课程一级分类" prop="course_cate_uuid" :label-width="labelWidth">
					<el-select style="width: 650px;" @change="changeType" v-model="ruleForm.course_cate_uuid"
						placeholder="请选择课程一级分类">
						<el-option v-for="item in level" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="课程二级分类" prop="sub_course_cate_uuid" :label-width="labelWidth">
					<el-select style="width: 650px;" v-model="ruleForm.sub_course_cate_uuid" placeholder="请选择课程二级分类">
						<el-option v-for="item in levelChild" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="课程权重" prop="weight" :label-width="labelWidth">
					<el-input style="width: 650px;" placeholder="请输入大于0的数字" v-model="ruleForm.weight"></el-input>
					<div style="color: #999;">权重数字越大排序越靠前，子级分类仅跟同一父级下比较</div>
				</el-form-item>
				<el-form-item label="课程封面" prop="img" :label-width="labelWidth">
					<ImageUpload :limit='1' @input='imageUpload' :onloadImageList='onloadImageList'></ImageUpload>
					<div style="color: #999;">支持扩展名：.png .jpg .jpeg 请上传小于20M图片，建议上传16:9格式图片</div>
				</el-form-item>

				<el-form-item label="课程介绍" prop="desc" :label-width="labelWidth">
					<QuillEditor :value="desc" @input='editorInput'></QuillEditor>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card shadow="never" style="margin-top: 20px;">
			<div slot="header" class="clearfix">
				<h4>课程章节</h4>
			</div>

			<el-collapse>
				<el-collapse-item v-model='activeName' v-for="(item,index) in ruleForm.chapter" :name="index+1">
					<template slot="title">
						<div class="flex flex-b" style="width: 100%;">
							<div>第{{(index+1)}}章</div>
							<i v-if="index!=0" class="el-icon-delete-solid" style="color: #ff0000;margin-right: 10px;"
								@click="ruleForm.chapter.splice(index,1)"></i>
						</div>
					</template>
					<el-form :model="zjruleForm" :rules="zjrules" ref="ruleForm2" label-width="100px"
						class="demo-ruleForm">
						<el-form-item label="章节名称" :label-width="labelWidth" prop='zjName'>
							<el-input style="width: 650px;" v-model="item.name" placeholder="请输入1-30位章节名称，仅支持字母/汉字/数字"
								show-word-limit maxlength="30"></el-input>
						</el-form-item>
						<el-form-item label="章节描述" :label-width="labelWidth" prop='zjDesc'>
							<el-input style="width: 650px;" v-model="item.desc" placeholder="请输入1-50位章节描述，仅支持字母/汉字/数字"
								type='textarea' :rows='4' show-word-limit maxlength="50"></el-input>
						</el-form-item>
						<el-form-item label="章节售价" :label-width="labelWidth" prop='zjScore'>
							<el-input style="width: 650px;" v-model="item.score" @input="totalPriceChange(index)"
								type='number' placeholder="请输大于0的数字"></el-input>
						</el-form-item>
						<el-form-item label="章节类型" :label-width="labelWidth">
							<el-select style="width: 650px;" v-model="item.type" placeholder="请选择章节类型">
								<el-option :key="1" label="视频" :value="1" />
								<el-option :key="2" label="音频" :value="2" />
								<el-option :key="3" label="PDF" :value="3" />
								<el-option :key="4" label="PPT" :value="4" />
							</el-select>
						</el-form-item>
						<el-form-item v-if="item.type == 1" label="视频上传" :label-width="labelWidth">
							<VideoUpload :key="'video-' + index" :limit='1'
								@input='videoUpload' :value='item.file.url' :currentIndex='index'>
							</VideoUpload>

							<div v-if="item.file.url" class="pointer" style="color: #409EFF;"
								@click="editAdminClick(item,index)">添加章节要点
							</div>
						</el-form-item>
						<el-form-item v-if="item.type == 2" label="音频上传" :label-width="labelWidth">
							<AudioUpload :limit='1' @input='videoUpload' :value='item.file.url' :currentIndex='index'>
							</AudioUpload>
						</el-form-item>
						<el-form-item v-if="item.type == 3|| item.type ==4" label="文件上传" :label-width="labelWidth">
							<UploadFile @input='fileUpload' :onloadImage='item.file.url' :currentIndex='index'>
							</UploadFile>
						</el-form-item>
						<el-form-item label="是否支持试看" :label-width="labelWidth">
							<el-radio-group v-model="item.is_see">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="2">否</el-radio>
							</el-radio-group>
						</el-form-item>

						<el-form-item v-if="item.is_see == 1 && (item.type == 1||item.type == 2)" label="试看秒数"
							:label-width="labelWidth">
							<el-input style="width: 650px;" v-model="item.seconds" type='number' placeholder="请输入试看秒数"
								@blur="parseInt(item.seconds)>parseInt(item.videoTime)?item.seconds=parseInt(item.videoTime):item.seconds"></el-input>
							<div v-if="duration" style="font-size: 12px;color: #999;">上传视频共{{duration}}，最多不可超过200秒：
							</div>
						</el-form-item>

						<el-form-item v-if="item.is_see == 1 && (item.type == 3|| item.type ==4)" label="试看文件"
							:label-width="labelWidth">
							<UploadFile :onloadImage='item.fee_file.url' @input='feeFileUpload' :currentIndex='index'>
							</UploadFile>
						</el-form-item>
					</el-form>
				</el-collapse-item>
			</el-collapse>
			<div class="flex flex-c" style="margin-top: 30px;">
				<el-button type="primary" style="width: 300px;" @click="addChapter">新增章节</el-button>
			</div>
		</el-card>

		<el-card shadow="never" style="margin-top: 20px;">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
				<el-form-item label="已有章节总售价" prop='totalPrice' :label-width="labelWidth">
					<el-input style="width: 650px;" v-model="ruleForm.totalPrice" placeholder="" disabled></el-input>
				</el-form-item>
				<el-form-item label="整课购买价格" prop='score' :label-width="labelWidth">
					<el-input style="width: 650px;" v-model="ruleForm.score" placeholder="请输入大于0的数字"
						type='number'></el-input>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button type="primary" style="width: 150px;" plain @click="resetForm('ruleForm')">返回</el-button>
			<el-button type="primary" style="width: 150px;" @click="submitForm('ruleForm')">保存</el-button>
		</el-card>

		<CoursePointsDialog :uuid="selectForm" :currentChapterIndexProp='currentChapterIndexProp'
			:dialogProp="editdialogVisible" @input="closeDialog" @confirm="confirmDialog">
		</CoursePointsDialog>
	</div>
</template>

<script>
	import CoursePointsDialog from "./components/CoursePointsDialog.vue"
	import QuillEditor from '@/components/quill-editor.vue'
	import ImageUpload from "../../components/ImageUpload.vue";
	import VideoUpload from "../../components/VideoUpload.vue";
	import AudioUpload from "../../components/AudioUpload.vue";
	import UploadFile from "../../components/UploadFile.vue";
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import {
		addCourse,
		updateCourse,
		getCourseDetail,
		getCourseCateList
	} from "@/api/course"
	import {
		getMemberList
	} from "@/api/user"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				editdialogVisible: false,
				selectForm: {},
				labelWidth: '150px',
				radio: '2',
				activeTab: 'first',
				imgDomain,
				total: 0,
				page_size: 9,
				page_index: 1,
				doubaoList: [],
				num: 1,
				detailObject: {},
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				user_uuid: '',
				total1: 0,
				page_index1: 1,
				page_size1: 9,
				hisLists: [],
				value: '500',
				zjruleForm: {},
				ruleForm: {
					uuid: '',
					name: '',
					course_cate_uuid: '',
					sub_course_cate_uuid: '',
					weight: '',
					img: '',
					desc: '',
					totalPrice: '',
					score: '',
					chapter: [{
						name: '',
						desc: '',
						score: '',
						type: 1,
						file: {
							url: '',
							second: 0
						},
						fee_file: {
							url: '',
							second: 0
						},
						is_see: 1,
						seconds: '',
						points: [],
						videoTime: 0
					}]
				},
				zjrules: {
					zjName: [{
						min: 1,
						max: 30,
						message: '最大30个字符',
						trigger: 'blur'
					}],
					zjDesc: [{
						min: 1,
						max: 50,
						message: '最大50个字符',
						trigger: 'blur'
					}],
					zjScore: [{
						// 匹配大于0的数字（包括整数和小数）
						pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
						message: '必须输入大于0的数字',
						trigger: ['blur', 'change']
					}],
				},
				rules: {
					name: [{
						required: true,
						message: '请输入1-30个字符，仅支持字母/汉字/数字',
						trigger: 'blur'
					}, {
						min: 1,
						max: 30,
						message: '最大30个字符',
						trigger: 'blur'
					}],
					course_cate_uuid: [{
						required: true,
						message: '请选择课程一级分类',
						trigger: 'change'
					}],
					sub_course_cate_uuid: [{
						required: true,
						message: '请选择课程二级分类',
						trigger: 'change'
					}],
					weight: [{
						required: true,
						message: '请输入大于0的数字',
						trigger: 'blur'
					}, {
						// 匹配大于0的数字（包括整数和小数）
						pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
						message: '必须输入大于0的数字',
						trigger: ['blur', 'change']
					}],
					img: [{
						required: true,
						message: '请上传课程封面',
						trigger: 'blur'
					}],
					desc: [{
						required: true,
						message: '请输入培训介绍',
						trigger: 'blur'
					}],
					score: [{
						required: true,
						message: '请输入大于0的数字',
						trigger: 'blur'
					}, {
						// 匹配大于0的数字（包括整数和小数）
						pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
						message: '必须输入大于0的数字',
						trigger: ['blur', 'change']
					}],
					totalPrice: [{
						required: true,
						message: '请输入已有章节总售价',
						trigger: 'blur'
					}],

				},
				level: [],
				levelChild: [],
				onloadImageList: [],
				desc: '',
				members: [],
				currentChapterIndexProp: 0,
				duration: 0,
			};
		},
		components: {
			CommonPagination,
			ImageUpload,
			QuillEditor,
			VideoUpload,
			UploadFile,
			CoursePointsDialog,
			AudioUpload
		},
		async mounted() {
			const uuid = this.$route.query.uuid
			this.user_uuid = uuid
			this.getCourseCateList()
			this.getMemberList()
			if (uuid) {
				this.ruleForm.uuid = uuid
				this.getCourseDetail(uuid);
			}
		},
		methods: {
			zjName(e) {
				console.log(e, 9123)
			},
			editAdminClick(row, index) {
				this.editdialogVisible = true;
				this.selectForm = row;
				this.currentChapterIndexProp = index
			},
			closeDialog(row) {
				this.editdialogVisible = false;
			},
			confirmDialog(row, index) {
				this.ruleForm.chapter[index].points = row
				this.editdialogVisible = false;
			},
			changeType(e) {
				let itemChild = this.level.find(item => {
					return item.uuid == e
				})
				this.levelChild = itemChild.child
			},
			totalPriceChange(e) {
				this.ruleForm.chapter[e].score = Math.abs(this.ruleForm.chapter[e].score)
				let total = this.ruleForm.chapter.reduce((accumulator, currentObject) => {
					return accumulator + parseFloat(currentObject.score)
				}, 0);
				this.ruleForm.totalPrice = total
			},
			addChapter() {
				this.ruleForm.chapter.push({
					name: '',
					desc: '',
					score: '',
					type: 1,
					file: {
						url: '',
						second: 0
					},
					fee_file: {
						url: '',
						second: 0
					},
					is_see: 1,
					seconds: '',
					points: []
				})
			},
			editorInput(e) {
				this.ruleForm.desc = e
			},
			imageUpload(e) {
				this.ruleForm.img = imgDomain + e[0]
			},
			fileUpload(e, currentIndex) {
				if (e) {
					this.ruleForm.chapter[currentIndex].file.url = e
					this.ruleForm.chapter[currentIndex].file.second = 0
				} else {
					this.ruleForm.chapter[currentIndex].file.url = ''
					this.ruleForm.chapter[currentIndex].file.second = 0
				}
			},
			feeFileUpload(e, currentIndex) {
				if (e) {
					this.ruleForm.chapter[currentIndex].fee_file.url = e
					this.ruleForm.chapter[currentIndex].fee_file.second = 0
				} else {
					this.ruleForm.chapter[currentIndex].fee_file.url = ''
					this.ruleForm.chapter[currentIndex].fee_file.second = 0
				}
			},
			videoUpload(e, currentIndex, time) {
				if (e && e.length > 0) {
					// 保存用上传返回的 result（相对路径），不要拼签名 url / imgDomain
					const result = typeof e[0] === 'object' ? (e[0].result || e[0].url || '') : e[0]
					this.ruleForm.chapter[currentIndex].videoTime = time || 0
					this.ruleForm.chapter[currentIndex].file.url = result
					this.ruleForm.chapter[currentIndex].file.second = parseInt(time) || 0
				} else {
					this.ruleForm.chapter[currentIndex].file.url = ''
					this.ruleForm.chapter[currentIndex].file.second = 0
				}
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					this.submitFormConfirm()
				});
			},
			submitFormConfirm() {
				this.$refs.ruleForm1.validate((valid) => {
					if (valid) {
						if (!this.ruleForm.uuid) {
							this.addCourse()
						} else {
							this.updateCourse()
						}
					} else {
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.goBack()
			},
			async getCourseCateList() {
				let postData = {
					page_size: 9999,
					page_index: 1,
					level: 1,
					pid: ''
				};
				const {
					status,
					data
				} = await getCourseCateList(postData);
				if (status !== 200) return;
				this.level = data.result.data;
				let itemChild = this.level.forEach(item => {
					item.child.forEach(_item => {
						this.levelChild.push(_item)
					})
				})
			},
			async getMemberList() {
				let postData = {
					page_size: 9999,
					page_index: 1
				};
				const {
					status,
					data
				} = await getMemberList(postData);
				if (status !== 200) return;
				this.members = data.result.data;
			},
			async addCourse() {
				let arrschapt = this.ruleForm.chapter
				let arr = []
				arrschapt.forEach(item => {
					delete item.videoTime
					arr.push(item)
				})
				this.ruleForm.chapter = arr
				const {
					status,
					data
				} = await addCourse({
					...this.ruleForm
				});
				if (status !== 200) return;
				this.$message.success('新增成功')
				this.goBack()
			},
			async updateCourse() {
				let arrschapt = this.ruleForm.chapter
				let arr = []
				arrschapt.forEach(item => {
					delete item.videoTime
					arr.push(item)
				})
				this.ruleForm.chapter = arr
				const {
					status,
					data
				} = await updateCourse({
					...this.ruleForm
				});
				if (status !== 200) return;
				this.$message.success('修改成功')
				this.goBack()
			},
			goBack() {
				this.$router.go(-1)
			},
			async getCourseDetail(uuid) {
				const {
					data,
					status
				} = await getCourseDetail({
					uuid: uuid
				});
				if (status === 200) {
					this.ruleForm = data.result;
					this.ruleForm.chapter.forEach(item => {
						item.videoTime = item.file.second
						let obj = {
							url: item.file.url,
							second: item.file.second ? item.file.second : 0
						}
						item.file = obj
						item.fee_file.second = item.fee_file.second ? item.fee_file.second : 0
					})
					this.onloadImageList.push(this.ruleForm.img)
					this.desc = this.ruleForm.desc
					let total = this.ruleForm.chapter.reduce((accumulator, currentObject) => {
						return accumulator + parseFloat(currentObject.score)
					}, 0);
					this.ruleForm.totalPrice = total
				}
			},
			handleClickBack() {
				this.$router.back(-1);
			},
		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}

	::v-deep .el-collapse-item__header {
		font-size: 15px;
		font-weight: 600;
	}
</style>